export default __webpack_public_path__ + "static/accents-background-accent-tokens-light-66dbfb4e829c4716010f142dd10a6a2c.png";